import { ElibraryQuestionFrontend } from "@sabyr-dev/mist_elibrary/frontend";

export class AcademyItemFrontend extends ElibraryQuestionFrontend {
	displayTest(url: string): void {
		const parsed = new URL(url, window.location.origin);
		window.location.href = parsed.toString();
	}
}